// extracted by mini-css-extract-plugin
module.exports = {"gsapA4":"gsapA4_gsapA4__GHBtx"};